@if (!customHeader) {
  <div id="toolbar-menu">
    @if (!isMenuLess && !appConfig?.hideAppOnNavbarNavigation) {
      <span>
        @if (topNavSettings.showApps) {
          <span>
            @for (item of menus; track item; let i = $index) {
              <span>
                @if (item.children && item.children.length > 0) {
                  <span>
                    <button mat-button [matMenuTriggerFor]="menu.childMenu" #menuTrigger="matMenuTrigger"
                      fghoverTopnavDropDown  [menu]="menu.childMenu" [hoverTrigger]="menuTrigger"
                      [component]="localConfig.navigationSchema"
                      [ngClass]="[isActiveMenuGroup(item.children) ? 'active-top-menu-item' : '' , !item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none isMobileHide']">
                      @if (item.icon) {
                        <span>
                          <span [class]="item.icon"></span>
                        </span>
                        } &nbsp;{{item.name}}
                        <span class="fa fa-chevron-down fg-menu-chevron-icon"></span>
                      </button>
                      <client-top-nav-menu-item #menu [items]="item.children" [localConfig]="localConfig"></client-top-nav-menu-item>
                      @for (child of item.children; track child; let childIndex = $index) {
                        <span class="fg-display-none">
                          @if (topNavSettings.showMatMenuAsLink) {
                            <a mat-button
                              [routerLink]="getNamedPageUrl(child,childIndex)"
                              [ngClass]="[ !item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none isMobileHide'] ">
                              {{child.name}}
                            </a>
                          }
                        </span>
                      }
                    </span>
                  }
                  @if (!item.children || item.children.length <= 0) {
                    <span>
                      @if (!topNavSettings.showMatMenuAsLink) {
                        <button mat-button (click)="toggleActive(item,i)"
                          [ngClass]="[isActiveMenu(item.pageId ? item.pageId : item) ? 'active-top-menu-item' : '' , !item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none isMobileHide']">
                          @if (item.icon) {
                            <span>
                              <span [class]="item.icon"></span>
                            </span>
                            } &nbsp;
                            {{item.name}}
                          </button>
                        }
                        @if (topNavSettings.showMatMenuAsLink) {
                          <a mat-button [routerLink]="getNamedPageUrl(item,i)"
                            [ngClass]="[!item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none isMobileHide']">
                            {{item.name}}
                          </a>
                        }
                      </span>
                    }
                  </span>
                }
              </span>
            }
          </span>
        }
        @if (!isMenuLess && appConfig?.hideAppOnNavbarNavigation) {
          <span>
            @if (!isMenuLess && !topNavSettings.hideContextSwicher) {
              <fg-context-switcher [setContextOnLoad]="true"
                [component]="contextSettings">
              </fg-context-switcher>
            }
          </span>
        }
      </div>
      <div id="toolbar-options">
        @if (!isMenuLess && !topNavSettings.hideContextSwicher && !appConfig?.hideAppOnNavbarNavigation) {
          <fg-context-switcher
            [setContextOnLoad]="true" [component]="contextSettings">
          </fg-context-switcher>
        }
        @if (topNavSettings.showLogout) {
          <app-logout-button [isCustomMainNav]="true"></app-logout-button>
        }
      </div>
    }

    @if (customHeader && menus.length > 0) {
      <span class="toolbar-spacer"></span>
      @for (item of menus; track item; let i = $index) {
        <span>
          @if (item.children && item.children.length > 0) {
            <span>
              <button mat-button [matMenuTriggerFor]="menu.childMenu"
                [ngClass]="[!item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none d-md-none isMobileHide']">
                @if (item.icon) {
                  <span>
                    <span [class]="item.icon"></span>
                  </span>
                  } &nbsp; {{item.name}} &nbsp;
                  <span class="fa fa-chevron-down fg-menu-chevron-icon"></span>
                </button>
                <client-top-nav-menu-item #menu [items]="item.children"></client-top-nav-menu-item>
                @for (child of item.children; track child; let childIndex = $index) {
                  <span class="fg-display-none">
                    @if (topNavSettings.showMatMenuAsLink) {
                      <a mat-button [routerLink]="getNamedPageUrl(child,childIndex)"
                        [ngClass]="[!child.isMobileView ? 'isMobileShow' : 'd-block d-sm-none d-md-none isMobileHide']">
                        {{child.name}}
                      </a>
                    }
                  </span>
                }
              </span>
            }
            @if (!item.children || item.children.length <= 0) {
              <span>
                @if (!topNavSettings.showMatMenuAsLink) {
                  <button mat-button (click)="toggleActive(item,i)"
                    [ngClass]="[!item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none d-md-none isMobileHide']">
                    @if (item.icon) {
                      <span>
                        <span [class]="item.icon"></span>
                      </span>
                      } &nbsp;
                      {{item.name}}
                    </button>
                  }
                  @if (topNavSettings.showMatMenuAsLink) {
                    <a mat-button [routerLink]="getNamedPageUrl(item,i)"
                      [ngClass]="[!item.isMobileView ? 'isMobileShow' : 'd-block d-sm-none isMobileHide']">
                      {{item.name}}
                    </a>
                  }
                </span>
              }
            </span>
          }
        }